const versionConfig = {
    version: 'v0.1.0'
}

export default versionConfig